export const weatherCodeMap = {
  weatherCode: {
    0: {
      day: { description: "Unknown", icon: "na", color: "shadow" },
      night: {
        description: "Unknown",
        icon: "na",
        color: "shadow",
      },
    },
    1000: {
      day: { description: "Clear, Sunny", icon: "wi-day-sunny", color: "warm" },
      night: {
        description: "Clear",
        icon: "wi-night-clear",
        color: "warm",
      },
    },
    1100: {
      day: {
        description: "Mostly Clear",
        icon: "wi-day-sunny",
        color: "warm",
      },
      night: {
        description: "Mostly Clear",
        icon: "wi-night-clear",
        color: "warm",
      },
    },
    1101: {
      day: {
        description: "Partly Cloudy",
        icon: "wi-day-cloudy",
        color: "warm",
      },
      night: {
        description: "Partly Cloudy",
        icon: "wi-night-cloudy",
        color: "warm",
      },
    },
    1102: {
      day: { description: "Mostly Cloudy", icon: "wi-cloud", color: "shadow" },
      night: {
        description: "Mostly Cloudy",
        icon: "wi-cloud",
        color: "shadow",
      },
    },
    1001: {
      day: { description: "Cloudy", icon: "wi-cloudy", color: "shadow" },
      night: { description: "Cloudy", icon: "wi-cloudy", color: "shadow" },
    },
    2000: {
      day: { description: "Fog", icon: "wi-fog", color: "shadow" },
      night: { description: "Fog", icon: "wi-fog", color: "shadow" },
    },
    2100: {
      day: { description: "Light Fog", icon: "wi-fog", color: "shadow" },
      night: { description: "Light Fog", icon: "wi-fog", color: "shadow" },
    },
    4000: {
      day: { description: "Drizzle", icon: "wi-rain-mix", color: "wet" },
      night: { description: "Drizzle", icon: "wi-rain-mix", color: "wet" },
    },
    4001: {
      day: { description: "Rain", icon: "wi-rain-mix", color: "wet" },
      night: { description: "Rain", icon: "wi-rain-mix", color: "wet" },
    },
    4200: {
      day: { description: "Light Rain", icon: "wi-sleet", color: "wet" },
      night: { description: "Light Rain", icon: "wi-sleet", color: "wet" },
    },
    4201: {
      day: { description: "Heavy Rain", icon: "wi-rain", color: "wet" },
      night: { description: "Heavy Rain", icon: "wi-rain", color: "wet" },
    },
    5000: {
      day: { description: "Snow", icon: "wi-day-snow", color: "cold" },
      night: { description: "Snow", icon: "wi-day-snow", color: "cold" },
    },
    5001: {
      day: { description: "Flurries", icon: "wi-snow", color: "cold" },
      night: { description: "Flurries", icon: "wi-snow", color: "cold" },
    },
    5100: {
      day: { description: "Light Snow", icon: "wi-snow", color: "cold" },
      night: { description: "Light Snow", icon: "wi-snow", color: "cold" },
    },
    5101: {
      day: {
        description: "Heavy Snow",
        icon: "wi-snowflake-cold",
        color: "cold",
      },
      night: {
        description: "Heavy Snow",
        icon: "wi-snowflake-cold",
        color: "cold",
      },
    },
    6000: {
      day: {
        description: "Freezing Drizzle",
        icon: "wi-rain-mix",
        color: "cold",
      },
      night: {
        description: "Freezing Drizzle",
        icon: "wi-rain-mix",
        color: "cold",
      },
    },
    6001: {
      day: { description: "Freezing Rain", icon: "wi-hail", color: "cold" },
      night: { description: "Freezing Rain", icon: "wi-hail", color: "cold" },
    },
    6200: {
      day: {
        description: "Light Freezing Rain",
        icon: "wi-hail",
        color: "cold",
      },
      night: {
        description: "Light Freezing Rain",
        icon: "wi-hail",
        color: "cold",
      },
    },
    6201: {
      day: {
        description: "Heavy Freezing Rain",
        icon: "wi-hail",
        color: "cold",
      },
      night: {
        description: "Heavy Freezing Rain",
        icon: "wi-hail",
        color: "cold",
      },
    },
    7000: {
      day: { description: "Ice Pellets", icon: "wi-snow-wind", color: "cold" },
      night: {
        description: "Ice Pellets",
        icon: "wi-snow-wind",
        color: "cold",
      },
    },
    7101: {
      day: {
        description: "Heavy Ice Pellets",
        icon: "wi-snow-wind",
        color: "cold",
      },
      night: {
        description: "Heavy Ice Pellets",
        icon: "wi-snow-wind",
        color: "cold",
      },
    },
    7102: {
      day: {
        description: "Light Ice Pellets",
        icon: "wi-snow-wind",
        color: "cold",
      },
      night: {
        description: "Light Ice Pellets",
        icon: "wi-snow-wind",
        color: "cold",
      },
    },
    8000: {
      day: {
        description: "Thunderstorm",
        icon: "wi-thunderstorm",
        color: "storm",
      },
      night: {
        description: "Thunderstorm",
        icon: "wi-thunderstorm",
        color: "storm",
      },
    },
  },
};
